export type ToastVariantBase = 'info' | 'success' | 'warning' | 'danger';
// Acepta 'error' como alias legacy
export type ToastVariant = ToastVariantBase | 'error';

export function normalizeVariant(v?: ToastVariant): ToastVariantBase {
  if (v === 'error') return 'danger';
  return (v ?? 'info') as ToastVariantBase;
}

let handler: ((msg: string, variant?: ToastVariantBase) => void) | null = null;

export function setToast(h: (msg: string, variant?: ToastVariantBase) => void) {
  handler = h;
}

export function toast(msg: string, variant?: ToastVariant) {
  const v = normalizeVariant(variant);
  try { handler?.(msg, v); } catch { /* no-op */ }
}
